import React from 'react';

const PageNotFound = () => {

  return (
    <div className="position-absolute top-50 start-50 translate-middle w-100 text-center">
        <h1>404 Page Not Found</h1>
    </div>
  );
};

export default PageNotFound;
